import { Buffer } from 'buffer';

// TON libraries read Buffer while their modules are being initialized. Keep this
// in a standalone side-effect module so it runs before those imports are evaluated.
globalThis.Buffer = Buffer;
